module.exports = __webpack_public_path__ + "img/t_highfive.770df169.png";